// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueMaterial from 'vue-material'
import VueChartkick from 'vue-chartkick'
import Chart from 'chart.js'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import App from './App'
import router from './router'
import $ from 'jquery';
import '../src/assets/style.css'
import Chartist from 'chartist'

Vue.use(VueChartkick, {adapter: Chart})
Vue.use(VueMaterial)

Object.defineProperty(Vue.prototype, '$Chartist', {
  get () {
    return this.$root.Chartist
  }
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  data: () => ({
    urlAPI: 'https://dashboard.rsui.com.br/api/v1/',
    accessToken: localStorage.getItem('access_token')||'',
    expiration: localStorage.getItem('expiration')||'',
    Chartist: Chartist
  }),
  methods: {
    verifyUserLogged: function() {
      var _this = this;
      var current_time = Date.now() / 1000;
      if (this.expiration != "")
      {
        if (this.expiration < current_time) {
          var _this = this
          var settings = {
              async: true,
              crossDomain: true,
              url: _this.urlAPI + 'login/refresh/',
              type: 'GET',
              headers: {
                  'content-type': 'application/json',
                  'Authorization': 'Bearer ' + _this.accessToken
              }
          }
          $.ajax(settings)
              .done(function (data) {
                  var base64Url = data.access_token.split('.')[1];
                  var base64 = base64Url.replace('-', '+').replace('_', '/');
                  var token = JSON.parse(window.atob(base64));
                  localStorage.setItem('expiration', token.exp);
                  _this.expiration = token.exp;
                  localStorage.setItem('access_token', data.access_token);
                  _this.accessToken = data.access_token;
                  _this.exibeSpinner = false;
                  return true;
              })
              .fail(function (result) {
                  _this.$router.push('/');
                  return false;
              })
        }
        else
        {
          return true;
        }
      }
      else
      {
        _this.$router.push('/');
        return false;
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js